import React from 'react';
import { useSlate } from 'slate-react';

import { ToolbarButton } from '@plone/volto-slate/editor/ui';
import { SIMPLELINK } from '@plone/volto-slate/constants';

import circleMenuSVG from '@plone/volto/icons/circle-menu.svg';

import {
  toggleStyle,
  isLinkStyleActive,
} from '@redturtle/iovisit-theme/config/Slate/dropdownUtils';
import { insertToolbarButtons } from '@redturtle/iovisit-theme/config/Slate/utils';
import { LinkElement } from '@redturtle/iovisit-theme/config/Slate/Link/render';

const LinkButtonButton = ({ icon, active, ...props }) => {
  const CLASSNAME = 'ui button primary iv--button';
  const editor = useSlate();
  const isActive = isLinkStyleActive(editor, CLASSNAME);

  return (
    <ToolbarButton
      {...props}
      icon={icon}
      active={isActive}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
        toggleStyle(editor, { cssClass: CLASSNAME, isBlock: false });
      }}
    />
  );
};

export default function install(config) {
  const { slate } = config.settings;

  slate.buttons.linkButton = (props) => (
    <LinkButtonButton title="Stile bottone" icon={circleMenuSVG} {...props} />
  );
  slate.elements[SIMPLELINK] = LinkElement;

  //aggiungo il bottone alla toolbar, dopo link
  insertToolbarButtons(['linkButton'], SIMPLELINK, slate);

  //htmlTagToSlate deserializer is defined in ./Link/deserializer.js
  return config;
}
